import React from 'react';
import PropTypes from 'prop-types';

const Search = ({ css = {}, search = '', onChange = () => {}, onSubmit = () => {} }) => {
    const adjustHeightOfTextarea = () => {
        const element = document.getElementById('searchTrackingLinkTextArea');
        if (element.scrollHeight > 100) {
            element.style.height = '5px';
            element.style.height = `${element.scrollHeight + 10}px`;
        } else {
            element.style.height = '100px';
        }
    };
    return (
        <div className={css.SearchContainer}>
            <textarea
                id="searchTrackingLinkTextArea"
                className={css.SearchTextBox}
                value={search}
                onChange={event => {
                    adjustHeightOfTextarea();
                    if (event.target.value === '') {
                        // clear the search text & clear the filter
                        onSubmit(true);
                    } else {
                        onChange(event.target.value);
                    }
                }}
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        onSubmit();
                        event.preventDefault();
                    } else {
                        adjustHeightOfTextarea();
                    }
                }}
                placeholder="Paste a tracking link URL and click Search"
            />
            <button
                disabled={search === undefined || search.length === 0}
                onClick={onSubmit}
                className={css.SearchButton}
            >
                Search
            </button>
        </div>
    );
};

Search.propTypes = {
    css: PropTypes.objectOf(PropTypes.any),
    search: PropTypes.string,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default Search;
